import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';
import { AccessCodeService } from '../../providers/access-code.service';


@Component({
  standalone: false,
  selector: 'app-modal-enter-access-code',
  templateUrl: './modal-enter-access-code.component.html',
styleUrls:  ['./modal-enter-access-code.component.css']
})
export class ModalEnterAccessCodeComponent  extends SmsAbstractAppPage implements OnInit {

	@Output() horse_show_unlocked$: EventEmitter<string> = new EventEmitter<string>();
	@Input() horse_show_id: string;

  constructor(public activeModal: NgbActiveModal, private accessCodeService: AccessCodeService){
  	super();
  	 }

  ngOnInit() {
  }

  handleSubmitAccessCode(access_code: string): void {
  	 this.accessCodeService.submitAccessCode(this.horse_show_id, access_code).then((access_code_claim_response: any) => {

  		if(access_code_claim_response.accepted && this.horse_show_id == access_code_claim_response.horse_show_id){
  			this.horse_show_unlocked$.emit(access_code_claim_response.horse_show_id);
  		} else {
  			this.handleError(access_code_claim_response);
  		}

  	}).catch(error => {
  		this.handleError(error);
  	});
  }

}
